<template>
  <div class="leaderboardmobile" v-if="mobile">
    <div class="leaderboardmobile" style="flex: 1;">
      <div class="tw-text-center tw-bg-grey tw-text-grey-darkest">
        NOT OFFICIAL TIMING
      </div>
      <table>
        <thead>
        <tr>
          <th v-if="showPositions">#</th>
          <th>NAME</th>
          <th v-if="!staggeredStart">DISTANCE</th>
          <th v-else>SPEED</th>
          <th>TIME</th>
          <th> </th>
          </tr>
        </thead>
        <tbody id="leaderbody1">
        <tr v-for="athlete in filterSorted">
          <td v-if="showPositions" v-on:click="log(athlete)"><span class="position">{{athlete.position}}</span></td>
          <td style="width: 50%" v-if="athlete.team_id == null" v-on:click="log(athlete)"><img v-if="athlete.country_code" style="height:20px; width:20px;" v-bind:src="getFlag(athlete)"> {{athlete.first_name}} {{athlete.last_name}} {{athlete.bib_id ? '(' + athlete.bib_id + ')' : null}}</td>
          <td v-else-if="athlete.team.name" v-on:click="log(athlete)"><img style="height:15px; width:15px;" v-bind:src="getFlag(athlete)"> {{athlete.team.name}}</td>
          <td v-if="!staggeredStart" v-on:click="log(athlete)" style="text-align: right; white-space: nowrap">{{ distance(athlete) }}</td>
          <td v-else v-on:click="log(athlete)" style="text-align: right">{{ speed(athlete) }}</td>
          <td v-on:click="log(athlete)" style="text-align: center" class="finisho">{{time(athlete)}}</td>
          <td v-on:click="toggleFavourite(athlete)" class="fav">
            <favIcon v-if="athlete.first_name" v-bind:gender="athlete.gender"
                     v-bind:aid="athlete.id"/>
            <favIcon v-else-if="athlete.team_name" v-bind:gender="athlete.gender"
                     v-bind:aid="athlete.team_id"/>
          </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else-if="!mobile">
    <div class="leaderboard tw-overflow-x-scroll" style="flex: 1;">
      <div class="tw-text-center tw-bg-grey tw-text-grey-darkest tw-font-bold">
        NOT OFFICIAL TIMING
      </div>
      <table>
        <thead>
        <tr>
          <th v-if="showPositions">#</th>
          <th>NAME</th>
          <th v-if="!staggeredStart">DISTANCE</th>
          <th v-else>SPEED</th>
          <th>TIME</th>
          <th> </th>
          </tr>
        </thead>
        <tbody id="leaderbody1">
        <tr v-for="athlete in filterSorted">
          <td v-if="showPositions" v-on:click="log(athlete)"><span class="position">{{athlete.position}}</span></td>
          <td style="width: 50%" v-if="athlete.team_id == null" v-on:click="log(athlete)"><img v-if="athlete.country_code" style="height:20px; width:20px;" v-bind:src="getFlag(athlete)"> {{athlete.first_name}} {{athlete.last_name}} {{athlete.bib_id ? '(' + athlete.bib_id + ')' : null}}</td>
          <td v-else-if="athlete.team_id" v-on:click="log(athlete)"><img style="height:15px; width:15px;" v-bind:src="getFlag(athlete)"> {{athlete.team.name}}</td>
          <td v-if="!staggeredStart" v-on:click="log(athlete)" style="text-align: right;white-space: nowrap">{{ distance(athlete) }}</td>
          <td v-else v-on:click="log(athlete)" style="text-align: right">{{ speed(athlete) }}</td>
          <td v-on:click="log(athlete)" style="text-align: center" class="finisho">{{time(athlete)}}</td>
          <td v-on:click="toggleFavourite(athlete)" class="fav">
            <favIcon v-if="athlete.first_name" v-bind:gender="athlete.gender"
                     v-bind:aid="athlete.id"/>
           <favIcon v-else-if="athlete.team_name" v-bind:gender="athlete.gender"
                    v-bind:aid="athlete.team_id"/>
          </td>
        </tr>
        </tbody>
        </table>
    </div>
  </div>
</template>
<style>
.leaderboardmobile::-webkit-scrollbar {
  width: 8px;
}
</style>
<script>
import favIcon from './favicon'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      selectedCat: 'All Categories',
      runningTime: {}
    }
  },
  components: {
    favIcon
  },
  mounted () {
    setInterval(this.updateDateTime, 1000)
  },
  beforeDestroy () {
      this.$store.dispatch('loadSearch', '')
  },
  watch: {
    getAthletes: function () {
      this.$store.dispatch('createCategories')
    },
    selectedCat: function () {
      this.$store.dispatch('loadSelectedCat', this.selectedCat)
    }
  },
  computed: {
    ...mapGetters({
      searchTerm: 'search',
      mobile: 'mobile',
      category: 'selectedCat',
      categories: 'categories',
      favourites: 'favourites',
      getAthletes: 'athletes',
      starttime: 'starttime',
      currentTime: 'currentTime',
      sortedAthletes: 'sortedAthletes',
      focusedRace: 'focusedRace',
      staggeredStart: 'staggeredStart',
      showPositions: 'raceShowPositions',
      event: 'event'
    }),
    filterSorted () {
      return this.sortedAthletes.filter(athlete => {
        if (typeof (athlete) !== 'undefined') {
          if (this.category === 'All Categories' || this.category === athlete.category) {
            let searchRegex = new RegExp(this.searchTerm, 'i')
            let fullName = athlete.first_name + ' ' + athlete.last_name
            if(athlete.team_id) {
              for(let i in athlete.team.athletes){
                let team_athlete = athlete.team.athletes[i]
                if (searchRegex.test(team_athlete.first_name) || searchRegex.test(team_athlete.last_name) || searchRegex.test(athlete.team.name)) {
                  return athlete
                }
              }
            }
            else {
              if (searchRegex.test(athlete.first_name) || searchRegex.test(athlete.last_name) || searchRegex.test(athlete.bib_id) || searchRegex.test(fullName)) {
                return athlete
              }
            }
          }
        }
      })
    },
    leaderboardheight: function () {
      if (this.mobile) {
        let h = window.innerHeight - 70 - 50 - 36 - 36 - 75
        return {
          flex: 1
        }
      } else {
        let h = window.innerHeight - 70 - 58 - 36 - 36 - 53 - 15
        return {
          height: h + 'px'
        }
      }
    }
  },
  methods: {
    updateDateTime () {
      for (var key in this.getAthletes) {
        // let time = moment().unix() - moment.utc(this.getAthletes[key].race_start).unix()
        let dur = moment.duration(this.getAthletes[key].duration, 'seconds')
        this.$set(this.runningTime, key, Math.floor(dur.asHours()) + ':' + ((dur.minutes() < 10) ? '0' + dur.minutes() : dur.minutes()))
      }
    },
    distance: function (ath) {
      if(typeof ath.properties.distance === 'undefined') {return ''}
      else if (parseInt(ath.isFinished) === 1 || (typeof (ath.status) === 'undefined') || ath.status === null) {
        return (ath.properties.distance / 1000.0).toFixed(1) + ' km'
      } else {
        return '-'
      }
    },
    speed (ath) {
      if (parseInt(ath.isFinished) === 1) {
        return (ath.distance / 1000.0).toFixed(1) + ' km'
      } else if ((typeof (ath.status) === 'undefined') || ath.status === null) {
        return (ath.avgspeed) + ' km/h'
      } else {
        return '-'
      }
    },
    time: function (ath) {
      if(this.event.id === 310) {
          return '-'
      }
      if (ath.isFinished) {
        return this.toHHMMSS(ath.properties.duration)
      } else if (ath.withdrawn_at === null) {
        return ath.properties.duration > 0 ? this.toHHMMSS(ath.properties.duration) : '00:00:00'
      } else if (ath.withdrawn_at !== null) {
        return ' WD '
      }
    },
    getFlag: function (ath) {
      return ath.country_code === null ? '' : 'https://app.sportraxs.com/images/svg/' + ath.country_code.toLowerCase() + '.svg'
    },
    log: function (ath) {
      if (typeof (ath.first_name) !== 'undefined') {
        if (this.mobile) {
          this.$router.push({name: 'mathlete', params: { id: ath.id }})
        } else {
          this.$router.push({name: 'athlete', params: { id: ath.id }})
        }
      } else if (typeof (ath.team_name) !== 'undefined') {
        if (this.mobile) {
          this.$router.push({name: 'mathlete', params: { id: ath.team_id }})
        } else {
          this.$router.push({name: 'athlete', params: { id: ath.team_id }})
        }
      }
    },
    toggleFavourite: function (ath) {
      if (typeof (ath.id) !== 'undefined') {
        let index = this.favourites.indexOf(ath.id)
        if (index > -1) {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Athlete remove: ' + ath.id, label: 'Loaded', value: ''})
          this.$store.dispatch('removeFavourite', ath.id)
        } else {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Athlete add: ' + ath.id, label: 'Loaded', value: ''})
          this.$store.dispatch('addFavourite', ath.id)
        }
      } else if (typeof (ath.team_id) !== 'undefined') {
        let index = this.favourites.indexOf(ath.team_id)
        if (index > -1) {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Team remove: ' + ath.team_id, label: 'Loaded', value: ''})
          this.$store.dispatch('removeFavourite', ath.team_id)
        } else {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Team add: ' + ath.team_id, label: 'Loaded', value: ''})
          this.$store.dispatch('addFavourite', ath.team_id)
        }
      }
    },
    toHHMMSS: function (secs) {
      var secNum = parseInt(secs, 10) // don't forget the second param
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - (hours * 3600)) / 60)
      var seconds = secNum - (hours * 3600) - (minutes * 60)
      if ((minutes < 10)) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      if (hours < 10) {
        hours = '' + hours
      }
      var time
      if (hours === '0') {
        time = '0:' + minutes + ':' + seconds
      } else {
        time = hours + ':' + minutes + ':' + seconds
      }
      return time
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/leaderboard.vue